import { inject, Injectable, signal } from '@angular/core';
import { HelpService } from './help.service';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  private loading = signal<boolean>(true);
  private _helperService = inject(HelpService);

  constructor() { }

  show() {
    this.loading.set(true);
    this._helperService.hide();
  }

  hide() {
    this.loading.set(false);
    this._helperService.show();
  }

  getLoading() {
    return this.loading.asReadonly();
  }
}
